const loadingButtonViewTemplate = `
<button type="submit"
        id="submit"
        ng-class="{ 'disabled-loading': isDisabledLoading() }"
        class="{{allClasses}}"
        ng-disabled="isDisabled()"
        ng-click="submitFunction($event)"
        data-fired="{{processingText}}">
        <span>{{ defaultText }}</span>
</button>
`;
export default loadingButtonViewTemplate;
